import getAreaInfo from './interfaceData/getAreaInfo'
import getBaike from './interfaceData/getBaike'
import getChinaTotal from './interfaceData/getChinaTotal'
import getContents from './interfaceData/getContents'
import getForeignInfo from './interfaceData/getForeignInfo'

export default {
  getAreaInfo,
  getBaike,
  getChinaTotal,
  getContents,
  getForeignInfo
}
